import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import tourParticipantCustomFieldsApi from '@/features/dashboard/tourCustomFields/api/tourParticipantCustomFieldsApi.ts';
import { tourParticipantCustomFieldsApiQueryKeys } from '@/features/dashboard/tourCustomFields/api/tourParticipantCustomFieldsApi.queryKeys.ts';
import { customFieldDefinitionMapper } from '@/features/dashboard/tourCustomFields/types/BaseCustomFieldDefinitionDto.mapper.ts';
import { CustomFieldFormData } from '@/features/dashboard/tourCustomFields/schemas/_customFieldSchema.ts';

export default function useCreateCustomField(tourId: string) {
  const queryClient = useQueryClient();

  const createCustomField = async (
    fieldDefForm: CustomFieldFormData,
  ): Promise<void> => {
    const fieldDefDto = customFieldDefinitionMapper.fromFormToDto(fieldDefForm);
    return await tourParticipantCustomFieldsApi.createField(
      tourId,
      fieldDefDto,
    );
  };

  return useMutation({
    mutationFn: createCustomField,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tourParticipantCustomFieldsApiQueryKeys.allForTour(tourId),
      });
    },
    onError: (error: Error) => {
      toast('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas zapisywania danych.',
      });
    },
  });
}
